import {
  AvatarSize,
  avatarSizes,
} from "@certn/cascadia/components/avatar/types";
import { cssToken } from "@certn/cascadia/utils";
import { CascadiaTypographyStyle } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import RLSkeleton, {
  SkeletonProps as RLSkeletonProps,
} from "react-loading-skeleton";

import { getTextStyle } from "../../foundations/typography/styles";

import "react-loading-skeleton/dist/skeleton.css";

interface SkeletonProps extends RLSkeletonProps {
  textStyle?: CascadiaTypographyStyle;
  isAvatar?: boolean;
  size?: AvatarSize;
}

export const Skeleton = (props: SkeletonProps) => {
  const {
    textStyle = "global/body-secondary",
    isAvatar = false,
    size = "large",
    ...skeletonProps
  } = props;

  if (isAvatar) {
    const avatarSizeTokens = avatarSizes[size];

    return (
      <RLSkeleton
        height={cssToken(avatarSizeTokens.height)}
        width={cssToken(avatarSizeTokens.width)}
        containerClassName={css({
          display: "flex",
          height: cssToken(avatarSizeTokens.height),
          width: cssToken(avatarSizeTokens.width),
        })}
        borderRadius="50%"
        baseColor={cssToken("background-accent-neutral-medium")}
        highlightColor={cssToken("background-accent-neutral-weak")}
        {...skeletonProps}
      />
    );
  }

  return (
    <div className={skeletonProps.className}>
      <RLSkeleton
        borderRadius={cssToken("space-1")}
        baseColor={cssToken("background-accent-neutral-medium")}
        highlightColor={cssToken("background-accent-neutral-weak")}
        containerClassName={css(getTextStyle(textStyle))}
        {...skeletonProps}
      />
    </div>
  );
};
